import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix User Fields icon. Exported from Figma (Bombiix 2026). */
const UserFieldsIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <circle cx="9.99967" cy="6.00065" r="2.66667" stroke="currentColor" />
    <path
      d="M15.3337 13.666C15.3337 15.3229 15.3337 16.666 10.0003 16.666C4.66699 16.666 4.66699 15.3229 4.66699 13.666C4.66699 12.0092 7.05481 10.666 10.0003 10.666C12.9458 10.666 15.3337 12.0092 15.3337 13.666Z"
      stroke="currentColor"
    />
  </svg>
);

export default UserFieldsIcon;
